import React from 'react';

const Contact = () => {
  return (
    <section id="contact">
      <h1>Contact</h1>
      <p>This is the contact page.</p>
    </section>
  );
};

export default Contact;
